export enum ValidationErrorType {
  Required = 'required',
  InvalidFormat = 'invalid format',
  OneOfRequired = 'one of required'
}
